// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportingTypeAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  const { curry } = require('lodash/fp');

  var SearchCriteriaAction = compose(
      withHandlers({
        handleChangeReportName:  curry(handleChangeReportName),
        handleChangeReportType:  curry(handleChangeReportType),
        handleBlur:  curry(handleBlur)
      })
  );

  /**
   * Handle change report name
   * @param props
   * @param newVal
   */
  function handleChangeReportName (props, newVal) {
    props.criteria.setValueByKey('name', newVal);
  }

  /**
   * Handle change report type
   * @param props
   * @param newVal
   */
  function handleChangeReportType (props, newVal) {
    var loader = props.loader;
    loader.startLoading();
    props.criteria.setValueByKey('reportType', newVal.value);
    props.store.loadReportDashboardName().finally(loader.endLoading.bind(loader));
  }

  /**
   * Handle unfocus report/dashboard input control
   * @param props
   * @param value
   */
  function handleBlur (props, value) {
    props.onAddNewReportName(value);
  }

  module.exports = SearchCriteriaAction;

}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Scheduling/Izenda.ReportingTypeAction.js